import { useEffect } from 'react';

// Reconcile against a deadline: browsers can throttle intervals in hidden tabs.
export default function useQuizCountdown(seconds, paused, setSeconds) {
  const running = seconds !== null && seconds > 0;
  useEffect(() => {
    if (!running || paused) return undefined;
    const deadline = Date.now() + seconds * 1000;
    const update = () => setSeconds(Math.max(0, Math.ceil((deadline - Date.now()) / 1000)));
    const interval = window.setInterval(update, 1000);
    document.addEventListener('visibilitychange', update);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', update);
    };
    // Rebase only on manual pause/resume or countdown initialization/expiry.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [running, paused, setSeconds]);
}
